module.exports = __webpack_public_path__ + "img/app store.481fb71c.png";